/** 网站统计 — 统计 › 访问·点击分析 (pages/todaymall/statistics)。 */
export default {
  'pages.siteAnalytics.tab.analysis': "访问·点击分析",
  'pages.siteAnalytics.tab.realtime': "实时情况",
  'pages.siteAnalytics.loadFailed': "统计加载失败，请稍后重试。",
  'pages.siteAnalytics.notCollecting': "访问采集已关闭。需要在服务器开启网站统计功能后才会累积数据。",
  'pages.siteAnalytics.noDataYet': "还没有采集到访问数据。开启采集并有访问后会显示在这里。",
  'pages.siteAnalytics.firstDataDay': "访问数据从 {date} 开始，此前的日期为空。",

  'pages.siteAnalytics.filter.today': "今天",
  'pages.siteAnalytics.filter.last7': "最近7天",
  'pages.siteAnalytics.filter.last30': "最近30天",
  'pages.siteAnalytics.filter.last90': "最近90天",
  'pages.siteAnalytics.filter.deviceAll': "全部设备",
  'pages.siteAnalytics.filter.visitorAll': "新访·回访全部",
  'pages.siteAnalytics.filter.visitorNew': "新访客",
  'pages.siteAnalytics.filter.visitorReturning': "回访客",
  'pages.siteAnalytics.filter.compare': "对比期间 {from} ~ {to} · 韩国时间",
  'pages.siteAnalytics.filter.kst': "韩国时间",
  'pages.siteAnalytics.view.chart': "图表视图",
  'pages.siteAnalytics.view.table': "表格视图",

  'pages.siteAnalytics.device.pc': "PC",
  'pages.siteAnalytics.device.mobile_web': "手机浏览器",
  'pages.siteAnalytics.device.android': "Android 应用",
  'pages.siteAnalytics.device.ios': "iOS 应用",

  'pages.siteAnalytics.kpi.uv': "访客数 (UV)",
  'pages.siteAnalytics.kpi.uv.tip': "期间内的不同访客数。已登录访客按账号计，其余按浏览器或应用计。只打开一个页面、页面从未显示且没有任何点击的访问（自动抓取程序）不计入任何指标。",
  'pages.siteAnalytics.kpi.pv': "浏览量 (PV)",
  'pages.siteAnalytics.kpi.pv.tip': "打开页面（应用为界面）的次数。只更换搜索词或筛选条件不计入。",
  'pages.siteAnalytics.kpi.avgDwell': "平均停留时间",
  'pages.siteAnalytics.kpi.avgDwell.tip': "每次访问中页面实际可见时间的平均值，切到其他标签页的时间不计。",
  'pages.siteAnalytics.kpi.bounceRate': "跳出率",
  'pages.siteAnalytics.kpi.bounceRate.tip': "只看了一个页面就结束的访问占比，越低越好。",
  'pages.siteAnalytics.kpi.clicks': "总点击数",
  'pages.siteAnalytics.kpi.clicks.tip': "网页统计所有链接和按钮点击，应用只统计加入购物车和立即购买按钮。",
  'pages.siteAnalytics.kpi.vsPrevious': "较上一期间",
  'pages.siteAnalytics.kpi.noBaseline': "没有可比较的历史数据",

  'pages.siteAnalytics.duration.hm': "{h}小时{m}分",
  'pages.siteAnalytics.duration.ms': "{m}分{s}秒",
  'pages.siteAnalytics.duration.s': "{s}秒",
  'pages.siteAnalytics.unit.people': "{n}人",
  'pages.siteAnalytics.unit.times': "{n}次",

  'pages.siteAnalytics.trend.title': "UV / PV 趋势",
  'pages.siteAnalytics.trend.uv': "UV",
  'pages.siteAnalytics.trend.pv': "PV",
  'pages.siteAnalytics.trend.note': "每日UV是当天的访客数，多天来访的访客每天都会计入（合计大于期间UV）。",
  'pages.siteAnalytics.trend.col.date': "日期",

  'pages.siteAnalytics.devices.title': "访问设备",
  'pages.siteAnalytics.devices.center': "访客总数",
  'pages.siteAnalytics.devices.tip': "按访客计算的占比。应用从安装了新版本的设备开始统计。",

  'pages.siteAnalytics.topPages.title': "热门页面 TOP 10",
  'pages.siteAnalytics.topPages.col.page': "页面",
  'pages.siteAnalytics.topPages.col.pv': "PV",
  'pages.siteAnalytics.topPages.col.uv': "UV",
  'pages.siteAnalytics.topPages.col.avgDwell': "平均停留",
  'pages.siteAnalytics.topPages.col.bounceRate': "跳出率",
  'pages.siteAnalytics.topPages.bounceTip': "从该页面进入的访问中，没有再看其他页面就结束的占比。",

  'pages.siteAnalytics.modules.title': "页面点击数据",
  'pages.siteAnalytics.modules.col.module': "点击模块",
  'pages.siteAnalytics.modules.col.impressions': "曝光数",
  'pages.siteAnalytics.modules.col.clicks': "点击数",
  'pages.siteAnalytics.modules.col.ctr': "CTR",
  'pages.siteAnalytics.modules.tip': "曝光只在网页上统计（区域一半以上在屏幕内停留超过1秒计1次）。CTR为网页访问的点击÷曝光，点击数中也包含应用的按钮点击。",

  'pages.siteAnalytics.funnel.title': "购买转化漏斗",
  'pages.siteAnalytics.funnel.desc': "从浏览商品到付款各步骤的访客数及相对第一步的比例。",
  'pages.siteAnalytics.funnel.tip': "到达后面步骤的访客也计入前面的步骤。创建订单和付款完成按访问期间实际产生的订单统计，之后才到账的订单也算付款完成。非会员购买链接的订单不包含在内。",
  'pages.siteAnalytics.funnel.stepRate': "较上一步",
  'pages.siteAnalytics.funnel.step.list': "商品列表/搜索",
  'pages.siteAnalytics.funnel.step.detail': "商品详情",
  'pages.siteAnalytics.funnel.step.cart': "购物车",
  'pages.siteAnalytics.funnel.step.checkout': "开始结算",
  'pages.siteAnalytics.funnel.step.order': "创建订单",
  'pages.siteAnalytics.funnel.step.paid': "付款完成",

  'pages.siteAnalytics.page.home': "首页",
  'pages.siteAnalytics.page.overseas': "海外直购",
  'pages.siteAnalytics.page.mall': "自营商城",
  'pages.siteAnalytics.page.live': "直播",
  'pages.siteAnalytics.page.search': "搜索",
  'pages.siteAnalytics.page.image_search': "图片搜索",
  'pages.siteAnalytics.page.category': "分类",
  'pages.siteAnalytics.page.product': "商品详情",
  'pages.siteAnalytics.page.cart': "购物车",
  'pages.siteAnalytics.page.checkout': "订单页（开始结算）",
  'pages.siteAnalytics.page.checkout_payment': "付款中",
  'pages.siteAnalytics.page.order_complete': "下单完成页",
  'pages.siteAnalytics.page.mall_store': "店铺",
  'pages.siteAnalytics.page.live_products': "直播商品列表",
  'pages.siteAnalytics.page.live_search': "直播搜索",
  'pages.siteAnalytics.page.live_seller': "卖家页面",
  'pages.siteAnalytics.page.shop': "卖家店铺",
  'pages.siteAnalytics.page.picks': "推荐商品",
  'pages.siteAnalytics.page.share_rewards': "分享奖励说明",
  'pages.siteAnalytics.page.promo_video': "宣传视频",
  'pages.siteAnalytics.page.mypage': "我的页面",
  'pages.siteAnalytics.page.mypage_order': "我的订单",
  'pages.siteAnalytics.page.guest_order': "非会员订单查询",
  'pages.siteAnalytics.page.guest_buy': "非会员购买链接",
  'pages.siteAnalytics.page.message': "消息·咨询",
  'pages.siteAnalytics.page.help': "客服中心",
  'pages.siteAnalytics.page.auth': "登录·注册",
  'pages.siteAnalytics.page.info': "公司·条款",
  'pages.siteAnalytics.page.other': "其他",

  'pages.siteAnalytics.module.main_banner': "主横幅",
  'pages.siteAnalytics.module.product_card': "商品卡片",
  'pages.siteAnalytics.module.category_icon': "分类图标",
  'pages.siteAnalytics.module.store_area': "推荐店铺区域",
  'pages.siteAnalytics.module.live_area': "直播区域",
  'pages.siteAnalytics.module.market_area': "商城区域",
  'pages.siteAnalytics.module.event_banner': "活动横幅",
  'pages.siteAnalytics.module.search_button': "搜索按钮",
  'pages.siteAnalytics.module.cart_button': "加入购物车按钮",
  'pages.siteAnalytics.module.buy_now_button': "立即购买按钮",

  'pages.siteAnalytics.realtime.live': "实时更新中",
  'pages.siteAnalytics.realtime.autoRefresh': "每10秒自动刷新",
  'pages.siteAnalytics.realtime.sampledAt': "截至 {time}",
  'pages.siteAnalytics.realtime.unavailable': "无法读取实时在线信息（在线记录存储连接问题）。下面的数字并不表示没有人在线。",
  'pages.siteAnalytics.realtime.kpi.current': "当前在线人数",
  'pages.siteAnalytics.realtime.kpi.current.tip': "最近1分钟内页面处于打开状态的访客。被隐藏的标签页1分钟后不再计入。",
  'pages.siteAnalytics.realtime.kpi.todayVisitors': "今日访客数",
  'pages.siteAnalytics.realtime.kpi.todayPageviews': "今日浏览量",
  'pages.siteAnalytics.realtime.kpi.mobileShare': "移动端占比",
  'pages.siteAnalytics.realtime.kpi.mobileShare.tip': "当前在线访客中非PC浏览器的占比（手机浏览器 + 应用）。",
  'pages.siteAnalytics.realtime.kpi.avgDwell': "平均停留时间",
  'pages.siteAnalytics.realtime.vs5min': "较5分钟前",
  'pages.siteAnalytics.realtime.vsYesterday': "较昨日同一时刻",
  'pages.siteAnalytics.realtime.pcShare': "PC {rate}",

  'pages.siteAnalytics.realtime.chart.title': "实时在线人数 · 最近1小时",
  'pages.siteAnalytics.realtime.chart.summary': "当前 {current}人 · 最高 {peak}人",
  'pages.siteAnalytics.realtime.chart.series': "在线人数",
  'pages.siteAnalytics.realtime.devices.title': "在线设备",
  'pages.siteAnalytics.realtime.devices.center': "在线",
  'pages.siteAnalytics.realtime.topPages.title': "当前浏览最多的页面 TOP 5",
  'pages.siteAnalytics.realtime.topPages.note': "新版本之前的应用不会上报正在查看的界面，因此不会显示在这里。",

  'pages.siteAnalytics.realtime.list.title': "当前在线用户列表",
  'pages.siteAnalytics.realtime.list.total': "共 {n}人",
  'pages.siteAnalytics.realtime.list.truncated': "在线人数较多，仅显示最近接入的 {n}人。",
  'pages.siteAnalytics.realtime.list.search': "搜索 ID、IP、国家、浏览器、页面",
  'pages.siteAnalytics.realtime.chip.all': "全部",
  'pages.siteAnalytics.realtime.chip.member': "会员",
  'pages.siteAnalytics.realtime.chip.guest': "非会员",
  'pages.siteAnalytics.realtime.chip.mobile': "移动端",
  'pages.siteAnalytics.realtime.chip.pc': "PC",
  'pages.siteAnalytics.realtime.chip.kr': "韩国",
  'pages.siteAnalytics.realtime.chip.foreign': "海外",
  'pages.siteAnalytics.realtime.col.connectedAt': "接入时间",
  'pages.siteAnalytics.realtime.col.visitor': "访客 ID",
  'pages.siteAnalytics.realtime.col.nickname': "会员/昵称",
  'pages.siteAnalytics.realtime.col.ip': "IP 地址",
  'pages.siteAnalytics.realtime.col.country': "国家",
  'pages.siteAnalytics.realtime.col.device': "设备",
  'pages.siteAnalytics.realtime.col.browser': "浏览器",
  'pages.siteAnalytics.realtime.col.page': "当前页面",
  'pages.siteAnalytics.realtime.col.duration': "停留时间",
  'pages.siteAnalytics.realtime.col.status': "状态",
  'pages.siteAnalytics.realtime.status.active': "在线",
  'pages.siteAnalytics.realtime.status.idle': "待机",
  'pages.siteAnalytics.realtime.export.sheet': "实时在线访客",
  'pages.siteAnalytics.realtime.export.empty': "没有可导出的在线访客。",
};
